export default __webpack_public_path__ + "maps-examples-runtime-add-line-1200-af81f29f91cf08833924ccefdae666ca.webp";